import React, { useState, useEffect } from "react";
import MainLayout from "../Layouts/MainLayout";
import "../CSS/BlogPage.css";
import { useParams } from "react-router-dom";
import Commentbox from "../Components/comments";
import { useGetPost, useSectorPosts } from "../Utlis/useFetchData";
import DateConvert from "../Utlis/DateConverter";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ReMoCard from "../Components/ReMoCard";
import Loading from '../Components/Loading';

const initialState = {
  Sector: "",
  title: "",
  content: "",
  author: "",
  thumbnailUrl: "",
  createdAt: null,
  relatedImageUrls: [],
};

const BlogPage = () => {
  const { id } = useParams();
  const { data: postData, error: postError, loading: postLoading } = useGetPost(id);
  const { data: relatedPosts, error: relatedError, loading: relatedLoading } = useSectorPosts(postData?.Sector || '');

  const [formData, setFormData] = useState(initialState);

  useEffect(() => {
    if (postData) {
      setFormData(postData);
    }
  }, [postData]);

  if (postError) {
    return <div>Error fetching post: {postError.message}</div>;
  }

  if (relatedError) {
    return <div>Error fetching related posts: {relatedError.message}</div>;
  }

  const { title, Sector, content, author, thumbnailUrl, createdAt } = formData;
  const formattedDate = DateConvert(createdAt);

  const isLoading = postLoading || relatedLoading;

  return (
    
    <div>
      {isLoading ? <Loading /> : (<MainLayout>
      <HelmetProvider>
        <Helmet>
          <title>BlogWiki</title>
          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@type": "NewsArticle",
                "headline": "${title}",
                "image": ["${thumbnailUrl}"],
                "author": {
                  "@type": "Person",
                  "name": "${author}"
                },
                "publisher": {
                  "@type": "Organization",
                  "name": "BlogWiki",
                  "logo": {
                    "@type": "ImageObject",
                    "url": "${"https://firebasestorage.googleapis.com/v0/b/blogwikiadminuseraccess.appspot.com/o/images%2Fnews-posts%2FLogoTest.png?alt=media&token=873e9566-5226-41ed-89fd-17cf75208c73"}"
                  }
                },
                "datePublished": "${createdAt}",
                "articleSection": "${Sector}"
              }
            `}
          </script>
        </Helmet>
      </HelmetProvider>

      <div className="BpMainWrapper">
        {isLoading ? (
          <Loading />
        ) : (
          <>
            <div className="RelatedNewsWrap">
              <h3 className="RelatedHead">Related News</h3>
              <ReMoCard blogPosts={relatedPosts} />
            </div>
            <div className="NewsContentWrap">
              <div className="PostTitleWrap">
                <h1 className="PostTitleTag">{title}</h1>
              </div>
              <div className="PostInfoWrap">
                <p className="PostInfoPtag">
                  <b>Author: </b>
                  {author} | <b>Updated: </b>
                  {formattedDate} | {Sector}
                </p>
              </div>
              <img className="PostImgTag" src={thumbnailUrl} alt="ImageText" />
              {content.split("\n").map((paragraph, index) => (
                <p key={index} className="PostContentTag">
                  {paragraph}
                </p>
              ))}
              <Commentbox postid={id} />
            </div>
          </>
        )}
      </div>
    </MainLayout>)}
      
    </div>
  );
};

export default BlogPage;
